import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Brands.css";
import visaImg1 from "../img/brands/VISA/1__Felicitas Ernst_Visa_fotografía_gato_2.webp";
import audiImg1 from "../img/brands/AUDI/1_MG_0184-2.webp";
import spotifyImg1 from "../img/brands/spotify/1_Chris_Deimon_Felicitas_Ernst.webp";
import quakerImg1 from "../img/brands/quaker/1_Felicitas Ernst_Ad_Quaker.webp";
import laRochePosayImg1 from "../img/brands/larocheposay/1_Felicitas Ernst_La_Roche_Possay_advertising_Publicidad1_FelicitasErnst_La_Roche_posay_.webp";
import netflixImg1 from "../img/brands/netflix/1.Felicitasernst_ad_Netflix.webp";
import kermatoImg1 from "../img/brands/kermato/1_Felicitas_Ernst_KERMATO_advertising_3.webp";
import garnierImg1 from "../img/brands/garnier/1_Garnier_Felicitas_Ernst_Photography_.webp";
import emptyRoomsImg1 from "../img/brands/emptyrooms/Gnota_61778.webp";
import burgerKingImg1 from "../img/brands/burgerking/1_Felicitas Ernst_Burger_King_advertising_Publicidad_U0A1908.webp";
import buickImg1 from "../img/brands/buick/1_Felicitas_Ernst_fotografía.autos_MG_3505.webp";
import bbvaImg1 from "../img/brands/bbva/1_Felicitas_Ernst_bbva_advertising_Gato productora.webp";
import bacardiImg1 from "../img/brands/bacardi/1___MG_1535.webp";
import amazonImg1 from "../img/brands/amazon/1_Felicitas Ernst_Amazon_advertising_Publicidad_MG_5282.webp";
import jumexImg1 from "../img/brands/jumex/1_Felicitas_Ernst_Jumex_advertising_alazraki.webp";
import unionImg1 from "../img/brands/union-fresco/1_MG_0588.webp";
import real1 from "../img/brands/real/_MG_4097-Felicitas Ernst-FOTOGRAFIA-DOCUMENTARY-DOCUMENTAL.webp";
import luppa1 from "../img/brands/luppa/1_MG_0323Rayo_Feli_Ernst.webp";
import balance1 from "../img/brands/balance/1_FeliErnst_Balancel_amazon_fotografia__MG_7753.webp";
import dandy1 from "../img/brands/dandy/1_FeliErnst_Dandy_anteojos_fotografia_1U0A2349.webp";
import farmacia1 from "../img/brands/farmacias/_MG_2751_3.webp";
import logocomplete from "../img/logo-complete.png";
import edding1 from "../img/brands/edding/1_FeliErnst_fotografía_Edding38.webp";
import esponjabon1 from "../img/brands/esponjabon/1_FeliErnst_fotografía_Esponjabon_MG_0279 copia.webp";
import laveta1 from "../img/brands/laveta/1_Felicitas Ernst_fotografia - Azlo - Laveta (4).webp";
import puntomaq1 from "../img/brands/punto-maq/1_FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8436.webp";
import generalli1 from "../img/brands/generalli/3c2a81b7-b0c5-4856-bd41-c2b2c9ac8a6a_rw_3840-Felicitas Ernst-FOTOGRAFIA.webp";
import gnv from "../img/brands/government/9d4b5480-d8a5-4322-96f7-eeb8cdeca43c_rw_1200-Felicitas Ernst-FOTOGRAFIA.webp";
import publico from "../img/brands/publico/1A-Felicitas Ernst-FOTOGRAFIA-RANDOM.webp";

const brands = [
  { name: "VISA", subtitle: "Bank", images: [visaImg1], link: "/visa" },
  { name: "AUDI", subtitle: "Automobile", images: [audiImg1], link: "/audi" },
  {
    name: "AMAZON",
    subtitle: "E-commerce",
    images: [amazonImg1],
    link: "/amazon",
  },
  { name: "BBVA", subtitle: "Bank", images: [bbvaImg1], link: "/bbva" },
  {
    name: "BURGER KING",
    subtitle: "Fast Food",
    images: [burgerKingImg1],
    link: "/burgerking",
  },
  {
    name: "LA ROCHE POSAY",
    subtitle: "Skincare",
    images: [laRochePosayImg1],
    link: "/larocheposay",
  },
  {
    name: "SPOTIFY",
    subtitle: "Music",
    images: [spotifyImg1],
    link: "/spotify",
  },
  {
    name: "NETFLIX",
    subtitle: "Movie",
    images: [netflixImg1],
    link: "/netflix",
  },
  {
    name: "GARNIER",
    subtitle: "Beauty",
    images: [garnierImg1],
    link: "/garnier",
  },
  { name: "QUAKER", subtitle: "Food", images: [quakerImg1], link: "/quaker" },
  {
    name: "BACARDÍ",
    subtitle: "Alcohol",
    images: [bacardiImg1],
    link: "/bacardi",
  },
  {
    name: "EMPTY ROOMS",
    subtitle: "Home",
    images: [emptyRoomsImg1],
    link: "/emptyrooms",
  },
  { name: "JUMEX", subtitle: "Beverage", images: [jumexImg1], link: "/jumex" },
  { name: "REAL", subtitle: "Fashion", images: [real1], link: "/real" },
  { name: "LUPPA", subtitle: "Collections", images: [luppa1], link: "/luppa" },
  {
    name: "KERMATO",
    subtitle: "Beverage",
    images: [kermatoImg1],
    link: "/kermato",
  },
  {
    name: "ÚNICO FRESCO",
    subtitle: "Beverage",
    images: [unionImg1],
    link: "/unico-fresco",
  },
  { name: "EDDING", subtitle: "Store", images: [edding1], link: "/edding" },
  {
    name: "ESPONJABÓN",
    subtitle: "Hygiene",
    images: [esponjabon1],
    link: "/esponjabon",
  },
  {
    name: "LAVETA",
    subtitle: "Supplements",
    images: [laveta1],
    link: "/laveta",
  },
  {
    name: "PUNTO MAQ",
    subtitle: "Tools",
    images: [puntomaq1],
    link: "/punto-maq",
  },
  {
    name: "BUICK",
    subtitle: "Automobile",
    images: [buickImg1],
    link: "/buick",
  },
  {
    name: "BALANCE",
    subtitle: "Fashion",
    images: [balance1],
    link: "/balance",
  },
  { name: "DANDY", subtitle: "Fashion", images: [dandy1], link: "/dandy" },
  {
    name: "FARMACIAS SIMILARES",
    subtitle: "Health",
    images: [farmacia1],
    link: "/farmacias",
  },
  {
    name: "GENERALI & LA CAJA SEGUROS",
    subtitle: "Insurance",
    images: [generalli1],
    link: "/generali",
  },
  {
    name: "OPEN GOVERNMENT PARTNERSHIP",
    subtitle: "Government",
    images: [gnv],
    link: "/gnp",
  },
  {
    name: "PÚBLICO",
    subtitle: "Public",
    images: [publico],
    link: "/publico",
  },
];

const Brands = () => {
  const [hoveredBrand, setHoveredBrand] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const intervalRef = useRef(null);
  const navigate = useNavigate();

  // Detectar si es vista móvil
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleMouseEnter = (brand) => {
    if (!isMobile && brand.images.length > 0) {
      setHoveredBrand(brand);
      setCurrentImageIndex(0);
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex(
          (prevIndex) => (prevIndex + 1) % brand.images.length
        );
      }, 3000); // Cambiar cada 3 segundos
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      clearInterval(intervalRef.current);
      setHoveredBrand(null);
    }
  };

  const handleBrandClick = (link) => {
    if (link) {
      navigate(link, { target: "_blank" });
    }
  };

  return (
    <div className="brands-container">
      <div className="gallery-item">
        <span className="small-italic-title-brands">Advertising</span>
      </div>
      {brands.map((brand) => (
        <div
          key={brand.name}
          className="brand-name"
          onMouseEnter={() => handleMouseEnter(brand)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleBrandClick(brand.link)}
        >
          {brand.name}&nbsp;
          <span className="small-italic">{brand.subtitle}</span>
        </div>
      ))}
      {hoveredBrand && hoveredBrand.images.length > 0 && (
        <div className="brand-image">
          <img
            src={hoveredBrand.images[currentImageIndex]}
            alt={hoveredBrand.name}
          />
        </div>
      )}
      <div className="logo-container">
        <img src={logocomplete} alt="Logo" className="centered-logo" />
        <div className="hover-text">
          I'm thirty two years old, but I like to feel like a twelve-year-old.
          My spirit is free and adventurous. I come from a big family, nine
          siblings in all. I have spent all of my childhood in the countryside
          of Argentina riding horses. You will always see me with a camera in
          hand. Photography is my passion and my life. I discovered it while
          working in advertising agencies. I used it as my channel of
          communication when I had to get a lot of ideas across. Today, after
          years of study and work, photography is a question that I still don't
          answer. Some say that in order to perfect photographic technique you
          must focus on one thing, but the truth is that I can't. Whenever
          anyone asks me to shoot, I will say yes. Each project is different,
          and with each of them I grow a bit more as a professional. One thing
          is clear to me: we come into the world with a purpose, and when I am
          shooting for social campaigns or documentaries I feel that I am
          fulfilling mine.
        </div>
      </div>
    </div>
  );
};

export default Brands;
